<template>
  <v-container fluid no-gutters>
      <v-row no-gutters>
        <v-col>
          <clip :clip="broadcasterChoice.clip"></clip>
        </v-col>
      </v-row>
      <v-row no-gutters >
        <clip-information :iso="false" :clip="broadcasterChoice.clip" :game="broadcasterChoice.game" :user="broadcasterChoice.user">
        </clip-information>
      </v-row>
  </v-container>
</template>

<script>
import Clip from '@/components/Clip'
import ClipInformation from '@/components/ClipInformation'
import { mapGetters } from 'vuex'

export default {
  name: 'BroadcasterChoice',
  components: {
    Clip,
    ClipInformation
  },
  computed: {
    ...mapGetters([
      'broadcasterChoice'
    ])
  }
}
</script>

<style scoped>
  .container {
    padding: 0 !important;
    overflow-y: scroll;
    height: calc(100vh - 48px);

  }
  .container::-webkit-scrollbar {
      width: 8px;
  }
  .container::-webkit-scrollbar-track {
    background-color: #001529;
    box-shadow: inset 0 0 6px #6441a4;
    -webkit-box-shadow: inset 0 0 6px #6441a4;
  }
  .container::-webkit-scrollbar-thumb {
    background-color:#6441a4;
    outline: 1px solid #6441a4;
  }

</style>
